import actions from './actions-group.js'
import mutations from './mutations-group.js'
import getters from './getters-group.js'
import state from './state-group.js'

export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state
}